/**
 * Mock managers used by Calendar (and any other feature that needs a manager list while
 * the real Managers feature is unimplemented).
 *
 * TODO(api): when Managers ships, this file is **deleted**. Replace usages with:
 *   const { data: managers = [] } = useSWR('/managers', fetcher)
 * The shape of `Manager` (from @ludus/core) is the wire format already, so the only
 * UI-only fields lost on swap are `color` and `initials`. Either:
 *   (a) compute them on the fly from `managerDisplayName(m)` (initials = first letters
 *       of firstName + lastName; color = hash(id) → from a fixed palette), or
 *   (b) store them on the Manager record server-side under e.g. `displayColor`.
 */
import { asPipelineId, asManagerId, type Manager } from '@ludus/core'

export interface MockManager extends Manager {
  color: string
  initials: string
}

const MOCK_PIPELINE_ID = asPipelineId('mock-pipeline')

export const mockManagers: MockManager[] = [
  {
    id: asManagerId('mock-mgr-anna'),
    pipelineIds: [MOCK_PIPELINE_ID],
    firstName: 'Anna',
    lastName: 'Petrenko',
    middleName: null,
    externalRef: null,
    isActive: true,
    isDeleted: false,
    color: '#6366f1',
    initials: 'AP',
  },
  {
    id: asManagerId('mock-mgr-bohdan'),
    pipelineIds: [MOCK_PIPELINE_ID],
    firstName: 'Bohdan',
    lastName: 'Lysenko',
    middleName: null,
    externalRef: null,
    isActive: true,
    isDeleted: false,
    color: '#10b981',
    initials: 'BL',
  },
  {
    id: asManagerId('mock-mgr-clara'),
    pipelineIds: [MOCK_PIPELINE_ID],
    firstName: 'Clara',
    lastName: 'Moroz',
    middleName: null,
    externalRef: null,
    isActive: true,
    isDeleted: false,
    color: '#f59e0b',
    initials: 'CM',
  },
  {
    id: asManagerId('mock-mgr-dmytro'),
    pipelineIds: [MOCK_PIPELINE_ID],
    firstName: 'Dmytro',
    lastName: 'Shevchenko',
    middleName: null,
    externalRef: null,
    isActive: false,
    isDeleted: false,
    color: '#ec4899',
    initials: 'DS',
  },
  {
    id: asManagerId('mock-mgr-elena'),
    pipelineIds: [MOCK_PIPELINE_ID],
    firstName: 'Elena',
    lastName: 'Volkova',
    middleName: null,
    externalRef: null,
    isActive: true,
    isDeleted: false,
    color: '#06b6d4',
    initials: 'EV',
  },
]

export function findMockManager(id: string): MockManager | undefined {
  return mockManagers.find((m) => m.id === id)
}
